module.exports = __webpack_public_path__ + "img/up-arrow.8150422d.svg";